import { ObjectKeys } from 'helpers/ts-helpers';

import unitSystemsJson from '../constants/unit_systems.json';

const unitSystems = unitSystemsJson.unitSystems;
export enum UnitSystems {
  METRIC = 'metric',
  HYBRID1 = 'hybrid1',
  IMPERIAL = 'imperial',
  HYBRID2 = 'hybrid2',
}

export const unitSystemNames = {
  [UnitSystems.METRIC]: unitSystems.metric.name,
  [UnitSystems.HYBRID1]: unitSystems.hybrid1.name,
  [UnitSystems.IMPERIAL]: unitSystems.imperial.name,
  [UnitSystems.HYBRID2]: unitSystems.hybrid2.name,
};

export const UNITS = {
  [UnitSystems.METRIC]: unitSystems.metric.units,
  [UnitSystems.HYBRID1]: unitSystems.hybrid1.units,
  [UnitSystems.IMPERIAL]: unitSystems.imperial.units,
  [UnitSystems.HYBRID2]: unitSystems.hybrid2.units,
};

export const standardUnits = ObjectKeys(unitSystems.metric.units);

export type StandardUnit = (typeof standardUnits)[number];

export const getStdUnitInUnitSystem = (fromUnit: StandardUnit, unitSystem: UnitSystems): string =>
  unitSystems[unitSystem].units[fromUnit];
